import { isGlobalProject } from 'config';

import { CompanyRegistrationAddress } from '../components';
import { useCompanyRegistrationAddress } from '../hooks';
import { PageComponentProps } from '../types';

export const CompanyRegistrationAddressStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    files,
    submitDisabled,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    goToBack,
  } = useCompanyRegistrationAddress();

  return (
    <CompanyRegistrationAddress
      canGoBack={canGoBack}
      countries={countries}
      countriesLoading={countriesLoading}
      enabledFiles={isGlobalProject()}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
